import { useEffect, useRef } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const fire = (event, increment, geo = {}) => {
  axios.post(`${API}/stats/engage`, { event, increment, ...geo }).catch(() => {});
};

/**
 * Tracks engagement events across the site to boost site fans counter.
 * Fires once per session per event type to avoid spam.
 */
const EngagementTracker = () => {
  const tracked = useRef({});
  const geo = useRef({});

  useEffect(() => {
    // Fetch geo once
    fetch('https://ipapi.co/json/').then(r => r.json()).then(d => {
      if (d) geo.current = { city: d.city || '', country: d.country_name || '' };
    }).catch(() => {});
  }, []);

  useEffect(() => {
    const key = (k) => {
      if (tracked.current[k]) return false;
      tracked.current[k] = true;
      return true;
    };

    // Small delay to let geo resolve
    const timer = setTimeout(() => {
      const g = geo.current;

      // Device type detection
      const w = window.innerWidth;
      if (w < 768 && key('mobile_visit')) fire('mobile_visit', 5, g);
      else if (w < 1024 && key('tablet_visit')) fire('tablet_visit', 3, g);
      else if (key('desktop_visit')) fire('desktop_visit', 2, g);

      // Page visit tracking
      const path = window.location.pathname;
      // Exclude hidden pages from tracking
      if (path === '/summerfest') return;
      if (key(`page_${path}`)) {
        fire('page_visit', 1, g);
      }

      // Specific page bonuses
      if (path.startsWith('/sponsors') && key('sponsor_page')) fire('sponsor_page', 6, g);
      if (path === '/advertise' && key('advertise_page')) fire('advertise_page', 3, g);
      if (path === '/venue-registration' && key('venue_reg')) fire('venue_reg', 3, g);
      if (path === '/careers' && key('careers_page')) fire('careers_page', 5, g);
    }, 1500);

    // Social link clicks
    const handleClick = (e) => {
      const a = e.target.closest('a[href]');
      if (!a) return;
      const href = a.href || '';
      const g = geo.current;
      if (href.includes('facebook.com') && key('fb_click')) fire('facebook_click', 68, g);
      if (href.includes('instagram.com') && key('ig_click')) fire('instagram_click', 5, g);
      if (href.includes('tiktok.com') && key('tt_click')) fire('tiktok_click', 150, g);
      if (href.includes('threads.net') && key('th_click')) fire('threads_click', 30, g);
    };
    document.addEventListener('click', handleClick);

    return () => { document.removeEventListener('click', handleClick); clearTimeout(timer); };
  }, []);

  return null;
};

export default EngagementTracker;
